import Cookies from 'cookies';

export default function getUserSessionId(req, res) {
  const cookies = new Cookies(req, res);
  return cookies.get('user_session_id');
}
